import axios from "axios";
import Config from "../../../config";

const v2_actionEditarCrmSource = (id, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/sources/${id}/editar`,
        data
    });
};

export default v2_actionEditarCrmSource;
